import api from "../../../core/api";
import {
  DatePerformance,
  DateServiceReports,
  GroupedPeriodQuery,
  MachineStatus,
  PeriodQuery,
  RepairCosts,
  RepairCostsQuery
} from "../models/machineStatsModels";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.machineryApiBaseUrl };
}

class CustomerMachineStatsApi {
  getMachineStatus(id: string): Promise<MachineStatus> {
    return api.get<MachineStatus>(
      `/v1/customer/machines/${id}/stats/status`, { ...getRequestConfig() })
      .then(x => x.data);
  }

  getRepairCosts(id: string, query: RepairCostsQuery): Promise<RepairCosts> {
    return api.get<RepairCosts>(
      `/v1/customer/machines/${id}/stats/repair-costs`, { ...getRequestConfig(), params: query })
      .then(x => x.data);
  }

  getServiceReportHistory(id: string, query: PeriodQuery): Promise<DateServiceReports[]> {
    return api.get<DateServiceReports[]>(
      `/v1/customer/machines/${id}/stats/service-reports`, { ...getRequestConfig(), params: query })
      .then(x => x.data);
  }

  getPerformance(id: string, query: GroupedPeriodQuery): Promise<DatePerformance[]> {
    return api.get<DatePerformance[]>(
      `/v1/customer/machines/${id}/stats/performance`, { ...getRequestConfig(), params: query })
      .then(x => x.data);
  }
}

export default new CustomerMachineStatsApi();
